'use strict';

angular.module('app')
    .controller('SearchLaCtrl', function($scope, $rootScope, $timeout, $location, $routeParams, lang, locationInfo, info, config, utils, Search, SearchLiveaboard, HomePage, diviacLocalStorage, localStorageService, SeoService, Request, Wishlist, GTM, gettextCatalog) {

        var vm = this,
            selectedFilters,
            firstSeen = true,
            filterObject = {};

        vm.service = SearchLiveaboard;
        vm.slug = $routeParams.slug;
        vm.getList = getList;
        vm.getTrips = getTrips;
        vm.clearAll = clearAll;
        vm.hidePopup = hidePopup;
        vm.filter = {};
        vm.fullFiltersList = [];
        vm.currentPage = $location.search().page ? +$location.search().page : 1;
        vm.toggleParameters = toggleParameters;
        vm.setItinerary = setItinerary;
        vm.checkPreviousTrips = checkPreviousTrips;
        vm.filtersCount = 0;
        vm.experience = [];
        vm.time = utils.genereateMonthPicker();
        vm.clearDate = clearDate;
        vm.triggerWishlist = triggerWishlist;

        if (locationInfo.model === "Liveaboard Fleet") {
            locationInfo.model = "fleet";
        }

        GTM.variables({
            destination_name: locationInfo.title,
            destination_id: locationInfo.pk,
            destination_level : locationInfo.destinationLevel,
            country_name: locationInfo.model === "Country" ? locationInfo.title : locationInfo.countryTitle,
            country_id: locationInfo.model === "Country" ? locationInfo.pk : locationInfo.countryId,
            area_name: locationInfo.model === "Area" ? locationInfo.title : null,
            area_id: locationInfo.model === "Area" ? locationInfo.pk : null,
            destination_id: locationInfo.pk,
            destination_name: locationInfo.title,
            destination_slug: $routeParams.location
        });

        // vm.paginate = paginate;
        $scope.operator = {pageUrl: true};

        _.each(info.shop.EXPERIENCE_REQUIRED_DIVES, function(val) {
            vm.experience.push({
                title: val[1],
                id: val[0]
            });
        });

        vm.price = [];

        _.each(info.liveaboardSearchPriceFilter, function(val, key){
            vm.price.push({id: key, from: val.from, to: val.to});
        });

        vm.operator = 10;
        vm.popupHided = localStorageService.get('hidePopup');

        if (!vm.popupHided) {
            $timeout(hidePopup,10000);
        }

        vm.operatorsType = config.operatorsType;
        vm.changeLocation = changeLocation;
        vm.getTrips = getTrips;
        vm.noResultsAtAll = false;

        vm.redirectedFromDR = window.sessionStorage.getItem("redirectedFromDR");
        window.sessionStorage.removeItem("redirectedFromDR");

        utils.setCanonical(window.location.origin + window.location.pathname);

        var filtersKeys = [
            'departure_date',
            'departure_date_custom',
            'routes',
            'marine_life_critters',
            'experience',
            'parameters',
            'themes',
            'harbours',
            'duration',
            'price',
            'is_promotion',
            'sponsors',
            'view'
        ];

        if (diviacLocalStorage.get('departure_date')) {
            $location.search('departure_date', diviacLocalStorage.get('departure_date').id);
        } else if (diviacLocalStorage.get('departure_date_custom')) {
            $location.search('departure_date_custom', diviacLocalStorage.get('departure_date_custom'));
        } else if (diviacLocalStorage.get('date')) {
            var date = moment(diviacLocalStorage.get('date')[0]).startOf('month').format('YYYY-MM-DD'),
                month =  _.filter(vm.time, { from: date});

            if (month.length) {
                $location.search('departure_date', month[0].id);
            }
        }

        if ($location.search()) {
            _.each($location.search(), function(val, key) {
                if (filtersKeys.indexOf(key) >= 0) {
                    if (key == 'departure_date') {
                        var departure = _.find(vm.time, {
                            id: val
                        });

                        if (departure) {
                            filterObject[key] = departure.id;
                        }
                    } else if (key === 'is_promotion' || key === 'view' || key === 'departure_date_custom') {
                        filterObject[key] = val;
                    } else {
                        if (_.isArray(val)) {
                            filterObject[key] = {};
                            _.each(val, function(v) {
                                filterObject[key][v] = true;
                            });
                        } else {
                            filterObject[key] = {};
                            filterObject[key][val] = true;
                        }
                    }
                }
            });
            vm.selectedParams = filterObject;
        }

        vm.location = locationInfo;

        if (locationInfo.pk) {
            vm.searchQuery = locationInfo.title;

            SearchLiveaboard.getTag('sponsor',locationInfo).then(function(data) {
                vm.sponsors = data;
            });
            SearchLiveaboard.getTag('theme',locationInfo).then(function(data) {
                vm.themes = data;
            });
            SearchLiveaboard.getTag('route',locationInfo).then(function(data) {
                vm.routes = data;
            });
            SearchLiveaboard.getTag('marine-life-critter',locationInfo).then(function(data) {
                vm.marineLifeCritters = data;
            });

            SearchLiveaboard.getFilters(locationInfo).then(function(data) {
                vm.harbour = data.harbours;
                vm.filtersList = data.parameters;
                vm.resortDetails = data.resorts;
                vm.resortsCount = vm.resortDetails.slug == vm.slug ? vm.resortDetails.count : 0
                vm.itineraryLength = [];

                _.each(data.lengths, function(val) {
                    vm.itineraryLength.push({
                        title: gettextCatalog.getPlural(val, '{{ count }} night', '{{ count }} nights', {
                            count: val
                        }),
                        id: val
                    });
                });

                vm.toggleParameters();
            });

        }

        if (!vm.selectedParams.view) {
            vm.selectedParams.view = 'boats';
        }

        function getList(obj) {
            if (vm.selectedParams.view && vm.selectedParams.view !== 'boats') {
                return true;
            }

            vm.loader = true;

            delete obj.view;

            SearchLiveaboard.getList({
                page: vm.currentPage
            }, obj, vm.location).then(function(data) {
                if (data.count <= 0) {
                    //check if resorts count from same country 
                    if (vm.resortDetails.slug == vm.slug){
                        // when no results but there are resorts in this area - redirect there
                        vm.resortsCount = 1 ||vm.resortDetails.count;
                        if (vm.resortDetails.count > 0) { 
                            redirectToResorts();
                        }
                    } else {
                        //no results and no alternative resorts in this area
                        vm.noResultsAtAll = true;
                        vm.resortsCount = 0;
                    }
                }
                
                vm.shopList = data.results;
                vm.totalQty = data.count;
                vm.loader = false;

                if (firstSeen && data.results.length) {
                    var string = '';

                    _.each(data.results, function(val) {
                        string += val.id + ','
                    });

                    GTM.variables({ business_ids: string.slice(0,-1) });

                    firstSeen = false;
                }
                
                
                SeoService.generateMetaTags(gettextCatalog.getString('{{ qty }} Liveaboards in {{ location }} | PADI Travel', { qty: vm.totalQty, location: locationInfo.title }), 
                    gettextCatalog.getString('Browse all the liveaboards in {{ location }}, check out the services provided, read divers reviews and compare the available offers.', { location: locationInfo.title})
                )
            });
        }

        function getTrips(shop, url, revert) {
            shop.loader = true;

            delete selectedFilters.page;
            delete selectedFilters.parameters;
            delete selectedFilters.view;


            return SearchLiveaboard.getTrips(shop.id, url, selectedFilters, revert).then(function(data) {
                shop.trips = data;
                shop.loader = false;
            });
        }

        function checkPreviousTrips (trips, pass) {
            if (!trips) {
                return false;
            }

            if (pass) {
                return true;
            }

            var month = moment(selectedFilters.departure_date).month(),
                year = moment(selectedFilters.departure_date).year();

            if (!trips.previous && selectedFilters.departure_date && (month > moment().month() || year != moment().year())) {
                return true;
            }

            return false;
        }


        vm.searchLa = function(value) {
            if (value.length < 3) {
                return false;
            }

            return HomePage.search({
                q: value,
                kind: 10
            });
        }

        function changeLocation() {
            if (vm.operator !== 10) {
                $location.path(utils.generateHighlightsUrl($routeParams.slug, {
                    kind: vm.operator
                }));
            }
        }

        // vm.selectedParams = $location.search();

        function toggleParameters(removePage) {
            var obj = {},
                filtersCount = 0

            _.each(vm.selectedParams, function(val, key) {
                if (key === 'departure_date' || key === 'is_promotion' || key === 'view' || key === 'departure_date_custom') {
                    if (key === 'view' && firstSeen) {
                        return true
                    } else {
                        obj[key] = val;
                    }
                } else {
                    obj[key] = _.filter(_.map(val, function(v, k) {
                        if (v) {
                            return +k;
                        } else {
                            return null;
                        }
                    }), function(v) {
                        return v || _.isNumber(v);
                    });
                }

                if (_.isArray(obj[key]) && obj[key].length || key === 'is_promotion' && obj[key]) {
                    filtersCount++;
                }
                
                $location.search(key, obj[key]);
            });

            vm.filtersCount = filtersCount;
            if (removePage) {
                if (_.isEmpty(vm.selectedParams)) {
                    _.each(filtersKeys, function(val) {
                        $location.search(val, null);
                    });
                }

                $location.search('page', null);
                vm.currentPage = 1;
            }

            if (obj.departure_date) {
                var dep_date = _.find(vm.time, {
                    id: obj.departure_date
                });

                obj.departure_date = dep_date.from;
                obj.selected_month = dep_date.id !== '30-days';

                diviacLocalStorage.set('departure_date' ,dep_date);
                diviacLocalStorage.set('date',[dep_date.from,dep_date.to]);
                diviacLocalStorage.remove('departure_date_custom');
            } else if (obj.departure_date_custom) {
                diviacLocalStorage.set('departure_date_custom', obj.departure_date_custom);
                diviacLocalStorage.set('date',[obj.departure_date_custom,moment(obj.departure_date_custom).add(30,'d').format('YYYY-MM-DD')]);
                diviacLocalStorage.remove('departure_date');
            } else {
                diviacLocalStorage.remove('departure_date');
                diviacLocalStorage.remove('departure_date_custom');
                diviacLocalStorage.remove('date');
            }


            selectedFilters = obj;
            getList(obj);
            loadDates(obj);
        }

        function clearAll() {
            _.each(vm.selectedParams, function (val,key) {
                if (key !== 'departure_date' && key !== 'view') {
                    vm.selectedParams[key] = undefined;
                }
            });

            toggleParameters(1);
        }

        function loadDates () {
            if (vm.selectedParams.view !== 'dates') {
                return true;
            }

            if (selectedFilters && selectedFilters.departure_date) {
                selectedFilters.departure_date_less_then = moment(selectedFilters.departure_date).add(30,'d').format('YYYY-MM-DD');
            } else if (selectedFilters && selectedFilters.departure_date_custom) {
                selectedFilters.departure_date_less_then = moment(selectedFilters.departure_date_custom).add(30,'d').format('YYYY-MM-DD');
            }

            vm.loader = true;
            delete selectedFilters.view;
            // vm.tripPage = 1;

            SearchLiveaboard.getByDates(selectedFilters, vm.location, {page: vm.currentPage}).then(function(data) {
                vm.tripsList = data;
                vm.tripPaginated = data.results;
                vm.totalQty = data.count;

                SeoService.generateMetaTags(
                    gettextCatalog.getString('{{ qty }} Trips in {{ location }} | PADI Travel', {
                        qty: vm.totalQty,
                        location: locationInfo.title
                    }),
                    gettextCatalog.getString('Browse all the liveaboards  in {{ location }}, check out the services provided, read divers reviews and compare the available offers.', {
                        location: locationInfo.title
                    })
                )

                // paginate();
                vm.loader = false;
            });
        }

        function clearDate () {
            vm.selectedParams.departure_date = null;
            vm.toggleParameters(1);
        }

        function redirectToResorts () {
            window.sessionStorage.setItem("redirectedFromLA",true);
            window.location.href = utils.createURL(vm.resortDetails.searchUrl);
        }

        function setItinerary (obj, e, shop) {
            e.stopPropagation();
            if ($scope.operator.itineraryInfo && $scope.operator.itineraryInfo.itinerary.slug && obj.itinerarySlug === $scope.operator.itineraryInfo.slug) {
                return true;
            }

            $scope.operator = {
                info: {
                    slug: shop ? shop.slug : obj.shopSlug,
                    countrySlug: shop ? shop.referenceLocationCountrySlug : obj.countrySlug,
                },
                isSearchpage : true,
                pageURL: SearchLiveaboard.generateLAUrl(shop||obj),
                itineraryInfo : {
                    trip: obj,
                    shopTitle: shop ? shop.title : obj.title,
                    id: obj.id,
                    endDate: obj._endDate || moment(obj.startDate).add(obj.duration,'d'),
                    startDate: obj.startDate,
                    slug: obj.itinerarySlug,
                    itinerary: {
                        loading: true
                    }
                }
            };

            $rootScope.operator = {pageUrl: SearchLiveaboard.generateLAUrl(shop||obj)};

            return Request.get('shop/' + (obj.countrySlug || shop.referenceLocationCountrySlug) + '/' + (obj.shopSlug || shop.slug) + '/itineraries/' + obj.itinerarySlug + '/').then(function(res){
                $scope.operator.itineraryInfo.itinerary = res.data;
                $scope.operator.itineraryInfo.itinerary.loading = false;
                $scope.operator.itineraryInfo.itinerary.days = utils.bindItinerary($scope.operator.itineraryInfo.itinerary.days);
                $scope.operator.info.paymentInformation = res.data.paymentInformation;
                $scope.operator.info.cancellationMilestones = res.data.cancellationMilestones;
                $scope.operator.info.milestones = res.data.milestones;

                utils.bindLogistic($scope.operator.itineraryInfo.itinerary.descriptions);

                jQuery.fancybox.update();
            });
        }

        function hidePopup () {
            vm.popupHided = true;
            localStorageService.set('hidePopup', true);
        }

        function triggerWishlist (e, result) {
            e.stopPropagation();
            e.preventDefault();

            if (!$rootScope.user) {
                $rootScope.wishlist = result.slug;
                return;
            }

            var data = {item_type: 'Shop', item_slug: result.slug},
                type = 'add';

            if (result.isWishlist) {
                data = result.isWishlist;
                type = 'delete';
            }

            Wishlist[type](data).then(function (data) {
                if (result.isWishlist) {
                    result.isWishlist = false;
                }

                if (type === 'add') {
                    result.isWishlist = data.item.id;
                }
            });
        }

        $scope.$watch(function () {
            return vm.selectedParams.view;
        }, function (newVal,oldVal) {
            if (oldVal && newVal !== oldVal) {
                vm.toggleParameters(1);
            }
        });
    });
